import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { Menu, Layout } from 'antd';
import {
  MoneyCollectOutlined,
  InfoCircleOutlined,
  ReadOutlined,
  ContactsOutlined,
  BarChartOutlined,
  LaptopOutlined,
  UserOutlined,
  PullRequestOutlined,
  NumberOutlined,
  HighlightOutlined,
  PartitionOutlined,
  ReconciliationOutlined,
  QuestionCircleOutlined,
  AuditOutlined,
  FileWordOutlined,
} from '@ant-design/icons';
import { useRouter } from 'next/router';
import { RootStateOrAny, useSelector } from 'react-redux';
import Image from 'next/image';
import { sidenavPath } from './paths';

const { SubMenu } = Menu;
const { Sider } = Layout;

const SideNav = () => {
  const [collapsed, setCollapsed] = useState(
    JSON.parse(window.localStorage.getItem('collapseSidebar'))
  );

  const [activeKey, setactiveKey] = useState('/dashboard/courses');
  const [openKeys, setOpenKeys] = React.useState([]);
  const rootSubmenuKeys = [
    '/dashboard/information',
    '/dashboard/users',
    '/dashboard/doubts',
    '/dashboard/courses',
    '/dashboard/finance',
  ];
  const [informationActive, setInformationActive] = useState(false);
  const [courseActive, setCourseActive] = useState(false);
  const [userActive, setUserActive] = useState(false);
  const [roomActive, setRoomActive] = useState(false);
  const [mockTestActive, setMockTestActive] = useState(false);
  const [doubtActive, setDoubtActive] = useState(false);
  const [financeActive, setFinanceActive] = useState(false);
  const [instructorRequest, setInstructorRequest] = useState(false);
  const router = useRouter();

  const { user_type, permission } = useSelector((state: RootStateOrAny) => ({
    permission: state.auth?.creds?.user_data?.permission,
    user_type: state?.auth?.creds?.user_data?.user_type,
  }));

  const onOpenChange = (keys: any) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  useEffect(() => {
    let includes = sidenavPath.filter((each) => {
      if (router.pathname.includes(each)) {
        return each;
      }
    });
    setactiveKey(includes[0]?.toString());
    let compareKey = includes[0]?.toString();
    if (
      compareKey === '/dashboard/information/testimonials' ||
      compareKey === '/dashboard/information/company' ||
      compareKey === '/dashboard/information/blogs' ||
      compareKey === '/dashboard/information/landing' ||
      compareKey === '/dashboard/information/advertisement' ||
      compareKey === '/dashboard/information/terms-and-conditions' ||
      compareKey === '/dashboard/information/faq'
    ) {
      setInformationActive(true);
    } else if (
      compareKey === '/dashboard/rooms' ||
      compareKey === '/dashboard/rooms/report-issues' ||
      compareKey === '/dashboard/rooms/room'
    ) {
      setRoomActive(true);
    } else if (
      compareKey === '/dashboard/mock-test/list' ||
      compareKey === '/dashboard/mock-test/assign-test'
    ) {
      setMockTestActive(true);
    } else if (
      compareKey === '/dashboard/courses/course-request' ||
      compareKey === '/dashboard/courses/course-list' ||
      compareKey === '/dashboard/courses/free-trial'
    ) {
      setCourseActive(true);
    } else if (
      compareKey === '/dashboard/users/staff' ||
      compareKey === '/dashboard/users/instructor' ||
      compareKey === '/dashboard/users/client' ||
      compareKey === '/dashboard/users/partner'
    ) {
      setUserActive(true);
    } else if (
      compareKey === '/dashboard/doubts/requests' ||
      // compareKey === '/dashboard/doubts/reports' ||
      compareKey === '/dashboard/doubts/comments-reports'
    ) {
      setDoubtActive(true);
    } else if (compareKey === '/dashboard/finance/coupon') {
      setFinanceActive(true);
    }
    let subkey = rootSubmenuKeys.filter((each) => router.pathname.includes(each));
    setOpenKeys(subkey);
  }, []);

  useEffect(() => {
    let includes = sidenavPath.filter((each) => {
      if (router.pathname.includes(each)) {
        return each;
      }
    });
    setactiveKey(includes[0]?.toString());
  }, [router.pathname]);

  const onCollapse = (collapse) => {
    setCollapsed(collapse);
    window.localStorage.setItem('collapseSidebar', JSON.stringify(collapse));
  };

  return (
    <Sider
      collapsible
      // collapsed={JSON.parse(window.localStorage.getItem('collapseSidebar')) || false}
      collapsed={collapsed}
      onCollapse={onCollapse}
      className="dashboard-sidenav"
      style={{
        overflow: 'auto',
        height: '93vh',
        // position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
      }}
    >
      <div className="sider-logo">
        <Link href="/">
          <a>
            <Image src="/logo.png" alt="logo" width="150" height="46" />
          </a>
        </Link>
      </div>
      <Menu
        theme="light"
        mode="inline"
        openKeys={openKeys}
        onOpenChange={onOpenChange}
      >
        {user_type !== 'partner' && (
          <>
            <Menu.Item
              key="/dashboard/home"
              icon={<BarChartOutlined rev="" />}
              className={
                activeKey == '/dashboard/home' ? 'ant-menu-item-selected' : ''
              }
            >
              <Link href="/dashboard/home">
                <a>Dashboard</a>
              </Link>
            </Menu.Item>
            {/* <MenuItem
              defaultShow={true}
              url="/dashboard/home"
              icon={<BarChartOutlined rev="" />}
              classN={activeKey == '/dashboard/home' ? 'ant-menu-item-selected' : ''}
              title="Dashboard"
            /> */}
            {(permission?.course?.view_course ||
              permission?.requestcourse?.view_requestcourse ||
              permission?.coursetrial?.view_coursetrial) && (
              <SubMenu
                key="/dashboard/courses"
                icon={<ReadOutlined rev="" />}
                title="Courses"
                className={courseActive ? 'submenu-active' : ''}
              >
                {permission?.course?.view_course && (
                  <Menu.Item
                    key="1"
                    className={
                      activeKey == '/dashboard/courses/course-list'
                        ? 'ant-menu-item-selected'
                        : ''
                    }
                  >
                    <Link href="/dashboard/courses/course-list">
                      <a>Courses</a>
                    </Link>
                  </Menu.Item>
                )}
                {permission?.requestcourse?.view_requestcourse && (
                  <Menu.Item
                    key="/dashboard/courses/course-request"
                    className={
                      activeKey == '/dashboard/courses/course-request'
                        ? 'ant-menu-item-selected'
                        : ''
                    }
                  >
                    <Link href="/dashboard/courses/course-request">
                      <a>Course Requests</a>
                    </Link>
                  </Menu.Item>
                )}
                {permission?.coursetrial?.view_coursetrial && (
                  <Menu.Item
                    key="/dashboard/courses/free-trial"
                    className={
                      activeKey == '/dashboard/courses/free-trial'
                        ? 'ant-menu-item-selected'
                        : ''
                    }
                  >
                    <Link href="/dashboard/courses/free-trial">
                      <a>Free trial</a>
                    </Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {user_type === 'staff' && permission?.room?.view_room && (
              <SubMenu
                key="/dashboard/rooms"
                icon={<LaptopOutlined rev="" />}
                title="Rooms"
                className={roomActive ? 'submenu-active' : ''}
              >
                <Menu.Item
                  key="/dashboard/rooms/room"
                  className={
                    activeKey == '/dashboard/rooms/room'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/rooms/room">
                    <a>Room</a>
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/dashboard/rooms/report-issues"
                  className={
                    activeKey == '/dashboard/rooms/report-issues'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/rooms/report-issues">
                    <a>Report Issues</a>
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}

            {permission?.assesment?.view_assesment && (
              <Menu.Item
                key="/dashboard/assessment"
                icon={<FileWordOutlined rev="" />}
                className={
                  activeKey == '/dashboard/assessment'
                    ? 'ant-menu-item-selected'
                    : ''
                }
              >
                <Link href="/dashboard/assessment">
                  <a>Assessment</a>
                </Link>
              </Menu.Item>
            )}

            {permission?.modeltest?.view_modeltest && (
              <SubMenu
                key="/dashboard/mock-test"
                icon={<LaptopOutlined rev="" />}
                title="Mock Test"
                className={mockTestActive ? 'submenu-active' : ''}
              >
                <Menu.Item
                  key="/dashboard/mock-test/list"
                  className={
                    activeKey == '/dashboard/mock-test/list'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/mock-test/list">
                    <a>Test List</a>
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/dashboard/mock-test/assign-test"
                  className={
                    activeKey == '/dashboard/mock-test/assign-test'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/mock-test/assign-test">
                    <a>Assign Test</a>
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}
          </>
        )}

        {user_type === 'staff' && (
          <>
            {permission?.note?.view_note && (
              <Menu.Item
                key="/dashboard/notes"
                icon={<HighlightOutlined rev="" />}
                className={
                  activeKey == '/dashboard/notes' ? 'ant-menu-item-selected' : ''
                }
              >
                <Link href="/dashboard/notes">
                  <a>Notes</a>
                </Link>
              </Menu.Item>
            )}

            <SubMenu
              key="/dashboard/information"
              icon={<InfoCircleOutlined rev="" />}
              title="Information"
              className={informationActive ? 'submenu-active' : ''}
            >
              {permission?.company?.view_company && (
                <Menu.Item
                  key="/dashboard/information/company"
                  className={
                    activeKey == '/dashboard/information/company'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/information/company">
                    <a>Company</a>
                  </Link>
                </Menu.Item>
              )}

              {permission?.testimonial?.view_testimonial && (
                <Menu.Item
                  key="/dashboard/information/testimonials"
                  className={
                    activeKey == '/dashboard/information/testimonials'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/information/testimonials">
                    <a>Testimonials</a>
                  </Link>
                </Menu.Item>
              )}

              {permission?.blog?.view_blog && (
                <Menu.Item
                  key="/dashboard/information/blogs"
                  className={
                    activeKey == '/dashboard/information/blogs'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/information/blogs">
                    <a>Blogs</a>
                  </Link>
                </Menu.Item>
              )}

              {permission?.landingsection?.view_landingsection && (
                <Menu.Item
                  key="/dashboard/information/landing"
                  className={
                    activeKey == '/dashboard/information/landing'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/information/landing">
                    <a>Landing</a>
                  </Link>
                </Menu.Item>
              )}

              {permission?.advertisement?.view_advertisement && (
                <Menu.Item
                  key="/dashboard/information/advertisement"
                  className={
                    activeKey == '/dashboard/information/advertisement'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/information/advertisement">
                    <a> Advertisement</a>
                  </Link>
                </Menu.Item>
              )}

              {permission?.termscondition?.view_termscondition && (
                <Menu.Item
                  key="/dashboard/information/terms-and-conditions"
                  className={
                    activeKey == '/dashboard/information/terms-and-conditions'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/information/terms-and-conditions">
                    <a>Terms & Conditions</a>
                  </Link>
                </Menu.Item>
              )}

              {permission?.faq?.view_faq && (
                <Menu.Item
                  key="/dashboard/information/faq"
                  className={
                    activeKey == '/dashboard/information/faq'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/information/faq">
                    <a>FAQs</a>
                  </Link>
                </Menu.Item>
              )}
            </SubMenu>

            {permission?.user?.view_user && (
              <SubMenu
                key="/dashboard/users"
                icon={<UserOutlined rev="" />}
                title="Users"
                className={userActive ? 'submenu-active' : ''}
              >
                <Menu.Item
                  key="/dashboard/users/staff"
                  className={
                    activeKey == '/dashboard/users/staff'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/users/staff">
                    <a>Staff</a>
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/dashboard/users/instructor"
                  className={
                    activeKey == '/dashboard/users/instructor'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/users/instructor">
                    <a>Instructor</a>
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/dashboard/users/client"
                  className={
                    activeKey == '/dashboard/users/client'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/users/client">
                    <a>Client</a>
                  </Link>
                </Menu.Item>
                {permission?.partner?.view_partner && (
                  <Menu.Item
                    key="/dashboard/users/partner"
                    className={
                      activeKey == '/dashboard/users/partner'
                        ? 'ant-menu-item-selected'
                        : ''
                    }
                  >
                    <Link href="/dashboard/users/partner">
                      <a>Partner</a>
                    </Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {/* Doubts */}
            {permission?.doubt?.view_doubt && (
              <SubMenu
                key="/dashboard/doubts"
                icon={<QuestionCircleOutlined rev="" />}
                title="Doubt Post"
                className={doubtActive ? 'submenu-active' : ''}
              >
                <Menu.Item
                  key="/dashboard/doubts/requests"
                  className={
                    activeKey == '/dashboard/doubts/requests'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/doubts/requests">Post Requests</Link>
                </Menu.Item>
                {/* <Menu.Item
              key="/dashboard/doubts/reports"
              className={
                activeKey == '/dashboard/doubts/reports'
                  ? 'ant-menu-item-selected'
                  : ''
              }
            >
              <Link href="/dashboard/doubts/reports">Post Reports</Link>
            </Menu.Item> */}
                <Menu.Item
                  key="/dashboard/doubts/comments-reports"
                  className={
                    activeKey == '/dashboard/doubts/comments-reports'
                      ? 'ant-menu-item-selected'
                      : ''
                  }
                >
                  <Link href="/dashboard/doubts/comments-reports">
                    Comment Reports
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}

            {permission?.contactus?.view_contactus && (
              <Menu.Item
                key="/dashboard/lead"
                icon={<ContactsOutlined rev="" />}
                className={
                  activeKey == '/dashboard/lead' ? 'ant-menu-item-selected' : ''
                }
              >
                <Link href="/dashboard/lead">
                  <a>Lead</a>
                </Link>
              </Menu.Item>
            )}

            {permission?.task?.view_task && (
              <Menu.Item
                key="/dashboard/task"
                icon={<AuditOutlined rev="" />}
                className={
                  activeKey == '/dashboard/task' ? 'ant-menu-item-selected' : ''
                }
              >
                <Link href="/dashboard/task">
                  <a>Task</a>
                </Link>
              </Menu.Item>
            )}

            {permission?.tutor?.view_tutor && (
              <Menu.Item
                icon={<PullRequestOutlined rev="" />}
                key="/dashboard/users/pending-instructor"
                className={
                  activeKey == '/dashboard/users/pending-instructor' &&
                  'ant-menu-item-selected'
                }
                onClick={() => setInstructorRequest(true)}
              >
                <Link href="/dashboard/users/pending-instructor">
                  <a> Instructor Requests</a>
                </Link>
              </Menu.Item>
            )}

            {(permission?.voucher?.view_voucher ||
              permission?.balanceledger?.view_balanceledger) && (
              <SubMenu
                key="/dashboard/finance"
                icon={<MoneyCollectOutlined rev="" />}
                title="Finance"
                className={financeActive ? 'submenu-active' : ''}
              >
                {permission?.voucher?.view_voucher && (
                  <Menu.Item
                    key="/dashboard/finance/coupon"
                    className={
                      activeKey == '/dashboard/finance/coupon'
                        ? 'ant-menu-item-selected'
                        : ''
                    }
                  >
                    <Link href="/dashboard/finance/coupon">
                      <a>Coupon</a>
                    </Link>
                  </Menu.Item>
                )}
                {permission?.balanceledger?.view_balanceledger && (
                  <Menu.Item
                    key="/dashboard/finance/ledger"
                    className={
                      activeKey == '/dashboard/finance/ledger'
                        ? 'ant-menu-item-selected'
                        : ''
                    }
                  >
                    <Link href="/dashboard/finance/ledger">
                      <a>Ledger</a>
                    </Link>
                  </Menu.Item>
                )}
              </SubMenu>
            )}

            {permission?.refer?.view_refer && (
              <Menu.Item
                key="/dashboard/refer"
                icon={<NumberOutlined rev="" />}
                className={
                  activeKey == '/dashboard/refer' ? 'ant-menu-item-selected' : ''
                }
              >
                <Link href="/dashboard/refer">
                  <a>Refer</a>
                </Link>
              </Menu.Item>
            )}

            {permission?.partner?.view_partner && (
              <Menu.Item
                key="/dashboard/partners"
                icon={<PartitionOutlined rev="" />}
                className={
                  activeKey == '/dashboard/partners' ? 'ant-menu-item-selected' : ''
                }
              >
                <Link href="/dashboard/partners">
                  <a>Partners</a>
                </Link>
              </Menu.Item>
            )}
            {permission?.physicalclass?.view_physicalclass && (
              <Menu.Item
                key="/dashboard/physical-class"
                icon={<ReconciliationOutlined rev="" />}
                className={
                  activeKey == '/dashboard/physical-class'
                    ? 'ant-menu-item-selected'
                    : ''
                }
              >
                <Link href="/dashboard/physical-class">
                  <a>Physical Class</a>
                </Link>
              </Menu.Item>
            )}
          </>
        )}

        {user_type === 'partner' && (
          <>
            <Menu.Item
              key="/dashboard/partner-clients"
              icon={<PartitionOutlined rev="" />}
              className={
                activeKey == '/dashboard/partner-clients'
                  ? 'ant-menu-item-selected'
                  : ''
              }
            >
              <Link href="/dashboard/partner-clients">
                <a>Partner Clients</a>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/dashboard/clients-payment"
              icon={<MoneyCollectOutlined rev="" />}
              className={
                activeKey == '/dashboard/clients-payment'
                  ? 'ant-menu-item-selected'
                  : ''
              }
            >
              <Link href="/dashboard/clients-payment">
                <a>Clients Payment</a>
              </Link>
            </Menu.Item>
          </>
        )}
      </Menu>
    </Sider>
  );
};

export default SideNav;
